import {Injectable, OnDestroy} from '@angular/core';
import {takeUntilDestroy} from "take-until-destroy";
import {LogProxy} from "./log.proxy";
import * as logManager from './log.manager';
import {LogManager} from "./log.manager";
import {AppConfigurationService} from "../app-config/app-configuration.service";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

/**
 ****************************************************************
 * Service class for getting logger configuration from server.
 *
 * Written by: Stanislav Korobov
 ****************************************************************
 */
@Injectable({
  providedIn: 'root'
})
export class LogService {
  constructor(private logProxy: LogProxy,
              private configService: AppConfigurationService) {
  }

  public getUserData(): Observable<logManager.ILoggerConfig>{
    return this.logProxy.getLogConfig().pipe( map(res => {
      LogManager.parseLoadedConfig(res, this.configService.Config.WebApiUrl);
      return res;
    }));
  }
}

